export default {
    add_integration_title: "Add Integration",
    add_integration_save_integration: "Save",
    add_integration_type: "Select Integration to Add",
    add_integration_select_manufacturers: "Select vehicle manufacturers",
    add_integration_cerebrumX: "CerebrumX",
    add_integration_diesellaptops: "Diesel Laptops",
    "add_integration_wex-ws" : "WEX-WS",
    add_integration_success_message: "The Integration has been added successfully",
    add_integration_error_message: "The Integration could not be added",
    add_integration_select_account: "Select Account",
    add_integration_account: "Account",
    add_integration_click_message: "Click on save to add the new integration",
    add_integration_account_required: "Account selection is required",

}

